var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9844 4.84268V8.28984C18.3586 8.231 17.5454 8.09415 16.6458 7.77693C15.4713 7.3625 14.597 6.79586 14.0243 6.35712V13.3244L14.0097 13.3026C14.019 13.4408 14.0243 13.5815 14.0243 13.7235C14.0243 17.1834 11.0998 20 7.50434 20C3.90886 20 0.984375 17.1834 0.984375 13.7235C0.984375 10.2635 3.90886 7.44564 7.50434 7.44564C7.85645 7.44564 8.20192 7.4725 8.53941 7.52494V10.9222C8.21521 10.8109 7.86708 10.7508 7.50434 10.7508C5.80227 10.7508 4.41643 12.0837 4.41643 13.7235C4.41643 15.3633 5.80227 16.6961 7.50434 16.6961C9.20642 16.6961 10.5923 15.362 10.5923 13.7235C10.5923 13.6621 10.5909 13.6007 10.5869 13.5393V0H14.1652C14.1784 0.291635 14.1904 0.585833 14.2037 0.877468C14.2276 1.45178 14.4402 2.00307 14.8109 2.45459C15.2454 2.98542 15.8872 3.60194 16.788 4.0944C17.6317 4.55359 18.4237 4.75185 18.9844 4.84523V4.84268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.6770d5c918ca26787b4d3da07dc21669.svg";
export { ForwardRef as ReactComponent };